import React, { Component } from 'react';

class SubmitUpgradeOrgRequestModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgJoinResponseMessage: ""
		};
	}
	
	componentDidUpdate(prevProps, prevState) {
		if(prevProps.showSubmitUpgradeOrgRequestModal !== this.props.showSubmitUpgradeOrgRequestModal){
			if(this.props.showSubmitUpgradeOrgRequestModal) {
				this.submitUpgradeOrgRequestModalOpen.click();;
			} else {
				this.submitUpgradeOrgRequestModalClose.click();;
			}
		}
	}

	handleConfirm = (event) => {
		this.props.submitUpgradeRequest();
	}

	handleCancel = (event) => {
		this.props.hideSubmitUpgradeOrgRequestModal();
	}

	render () {

		return (
          <div>
          <input type="hidden" ref={elem => this.submitUpgradeOrgRequestModalOpen = elem} id="SubmitUpgradeOrgRequestModalOpen" data-bs-toggle="modal" data-bs-target="#SubmitUpgradeOrgRequestModal"/>
  			<div className="modal fade" id="SubmitUpgradeOrgRequestModal" tabIndex="-1" role="dialog" aria-labelledby="SubmitUpgradeOrgRequestModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                 <div className="modal-content">
                   <div className="modal-header">
                   		Submit Organization/Company Information
                   </div>
                   <div className="modal-body">
                    NOTE: Your organization/company information will be used to complete your personal address information if those fields
					have not been provided. To update personal information at any time, please go to Manage My Account > Account
					Settings screen.
                   </div>
                   <div className="modal-footer">
       				<button className='button secondary light-bg' onClick={this.handleConfirm} name="Confirm">
       					Confirm
            		</button>
       				<button className='button secondary light-bg' ref={elem => this.submitUpgradeOrgRequestModalClose = elem} onClick={this.handleCancel} data-bs-dismiss="modal" id="SubmitUpgradeOrgRequestModalClose" name="Cancel">
       					Cancel
            		</button>
                   </div>
                 </div>
               </div>
             </div>
           </div>
		)
	}
}

export default SubmitUpgradeOrgRequestModal;



// WEBPACK FOOTER //
// ./src/manageMyAccount/modals/SubmitUpgradeOrgRequestModal.js